import React from 'react';

// Bottom pagination bar: per-page selector, results summary, page buttons.
// Pure presentational — the owning screen holds page/perPage state and slices the list.
export default function Pager({ total, page, perPage, onPage, onPerPage, perPageOptions = [20, 40, 60, 80, 100] }) {
  const pages = Math.max(1, Math.ceil(total / perPage));
  const cur = Math.min(Math.max(1, page), pages);

  const seq = [];
  if (pages <= 5) {
    for (let i = 1; i <= pages; i++) seq.push(i);
  } else {
    seq.push(1);
    if (cur > 3) seq.push('…');
    const from = Math.max(2, cur - 1);
    const to = Math.min(pages - 1, cur + 1);
    for (let i = from; i <= to; i++) seq.push(i);
    if (cur < pages - 2) seq.push('…');
    seq.push(pages);
  }

  const prev = () => onPage(Math.max(1, cur - 1));
  const next = () => onPage(Math.min(pages, cur + 1));

  return (
    <div className="pager">
      <div className="pp">
        <span>Per page</span>
        <select className="pp-sel" value={perPage} onChange={(e) => onPerPage(Number(e.target.value))} aria-label="Per page">
          {perPageOptions.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>
      <span className="sum">
        {total.toLocaleString('en-US')} results · page {cur} of {pages}
      </span>
      <div className="pbtns">
        <button className="pbtn" onClick={prev} disabled={cur === 1}>
          ‹ Previous
        </button>
        {seq.map((p, i) =>
          p === '…' ? (
            <span key={`e${i}`} className="pell">
              …
            </span>
          ) : (
            <button
              key={p}
              className={`pbtn${p === cur ? ' on' : ''}`}
              aria-current={p === cur ? 'page' : undefined}
              onClick={() => onPage(p)}>
              {p}
            </button>
          )
        )}
        <button className="pbtn" onClick={next} disabled={cur === pages}>
          Next ›
        </button>
        <button className="pbtn" onClick={() => onPage(pages)} disabled={cur === pages} aria-label="Last page">
          »
        </button>
      </div>
    </div>
  );
}
